import React, { useState, useEffect } from "react";
import api from "../../../../Axios/api";
import {
  InputAdornment,
  Paper,
  Button,
  TextField,
  Container,
  Grid,
  Avatar,
  Typography,
} from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import { Redirect } from "react-router-dom";
import useStyles from "./styles";
import { useUserContext, updateProfile } from "../../../../context/UserContext";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

export default function ChangePassword() {
  const classes = useStyles();
  const { store, dispatch } = useUserContext();
  const token = store.data.token;

  const initialValues = {
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  };
  const validationSchema = Yup.object().shape({
    oldPassword: Yup.string().required("Password is Required!!"),
    newPassword: Yup.string().required("required"),
    confirmNewPassword: Yup.string().oneOf(
      [Yup.ref("newPassword"), null],
      "Passwords must match"
    ),
  });
  const onSubmit = (values, props) => {
    console.log(values);
    const { oldPassword, newPassword } = values;
    api
      .patch(
        "/superAdmin/updatePassword",
        {
          oldPassword,
          newPassword,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(async (res) => {
        const oldData = store.data.data;
        const newData = { ...oldData, ...adminData };

        setTimeout(function () {
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "Your Password has been updated Sucessfully!",
            open: true,
          });
          setTimeout(function () {
            updateProfile(dispatch, newData, token);
          }, 1000);
        }, 1000);
      })
      .catch((error) =>
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message:
            "ERROR: " + JSON.stringify(error.response.data.error.message),
          open: true,
        })
      );
  };
  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const [adminData, setAdminData] = useState({
    name: store.data.data.name,
    profilePic: store.data.data.profilePic,
  });
  const [isLoggedOut] = useState(false);

  return (
    <Grid container className={classes.root}>
      {isLoggedOut ? <Redirect to="/admin/login" /> : ""}
      <Grid item xs={12} sm={12} md={12} component={Paper}>
        <Container component="div" maxWidth="sm">
          <div className={classes.paper}>
            <Grid className={classes.settingsSpacing}>
              <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
              >
                {(props) => (
                  <Form className={classes.form}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        alignItems: "center",
                        marginBottom: "20px",
                      }}
                    >
                      <Avatar
                        alt="profile photo"
                        src={adminData.profilePic}
                        className={classes.avatarInProfileSetting}
                      >
                        {"LOGO HERE"}
                      </Avatar>
                      <div
                        style={{ marginTop: 80, marginRight: 30, fontSize: 50 }}
                      >
                        <Typography
                          style={{
                            fontSize: 25,
                            color: "blue",
                          }}
                        >
                          {adminData.name}
                        </Typography>
                      </div>
                    </div>

                    <Field
                      as={TextField}
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      label="Existing Password"
                      name="oldPassword"
                      required
                      helperText={<ErrorMessage name="oldPassword" />}
                      type="password"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <VpnKeyIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Field
                      as={TextField}
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      label="New Password"
                      name="newPassword"
                      type="password"
                      required
                      helperText={<ErrorMessage name="newPassword" />}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <VpnKeyIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Field
                      as={TextField}
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      label="Confirm New Password"
                      name="confirmNewPassword"
                      required
                      type="password"
                      helperText={<ErrorMessage name="confirmNewPassword" />}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <VpnKeyIcon />
                          </InputAdornment>
                        ),
                      }}
                    />

                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.submit}
                    >
                      SAVE CHANGES
                    </Button>
                  </Form>
                )}
              </Formik>
            </Grid>
          </div>
          <Snackbar
            open={open}
            anchorOrigin={{ vertical, horizontal }}
            autoHideDuration={3000}
            onClose={handleCloseSnackBar}
            key={vertical + horizontal}
          >
            <MuiAlert
              elevation={6}
              variant="filled"
              onClose={handleCloseSnackBar}
              severity={snackBarstate.type}
            >
              {snackBarstate.message}
            </MuiAlert>
          </Snackbar>
        </Container>
      </Grid>
      {/* <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFF",
            width: "70vw",
            height: "70vh",
            padding: "20px",
            position: "relative",
          }}
        ></div>
      </Modal> */}
    </Grid>
  );
}
